/**
 * UI mode. Per-user, client-side only — stored in localStorage.
 *
 */

export type UiMode = 'next'

const STORAGE_KEY = 'ui_mode'
const DEFAULT_MODE: UiMode = 'next'

export function getUiMode(): UiMode {
  const raw = localStorage.getItem(STORAGE_KEY)
  return raw === 'next' ? raw : DEFAULT_MODE
}

export function setUiMode(mode: UiMode): void {
  localStorage.setItem(STORAGE_KEY, mode)
  window.location.reload()
}
